import { render, staticRenderFns } from "./public-menu-entry.vue?vue&type=template&id=771a95d2&scoped=true&"
import script from "./public-menu-entry.ts?vue&type=script&lang=ts&"
export * from "./public-menu-entry.ts?vue&type=script&lang=ts&"
import style0 from "./public-menu-entry.scss?vue&type=style&index=0&id=771a95d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a95d2",
  null
  
)

export default component.exports